import { useEffect, useContext } from "react";
import { LanguageContext } from "../../../context/LanguageContext";

export default function Contact() {
  const { t, isRTL } = useContext(LanguageContext);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <main dir={isRTL ? "rtl" : "ltr"} className="bg-gray-50">

      {/* HERO */}
      <section className="bg-white py-24">
        <div className="mx-auto max-w-4xl px-6 text-center">
          <h1 className="text-4xl font-bold text-gray-900">
            {t("contactPage.hero.title")}
          </h1>
          <p className="mt-4 text-lg text-gray-600">
            {t("contactPage.hero.subtitle")}
          </p>
        </div>
      </section>

      {/* CONTACT CONTENT */}
      <section className="py-16">
        <div className="mx-auto max-w-6xl px-6">
          <div className="grid gap-12 lg:grid-cols-2">

            {/* LEFT */}
            <div className="rounded-2xl bg-white p-8 shadow-sm">
              <h2 className="text-2xl font-semibold text-gray-900">
                {t("contactPage.info.title")}
              </h2>

              <div className="mt-6 space-y-4 text-gray-700">
                <p>
                  <strong>{t("contactPage.info.emails.general")}:</strong>{" "}
                  <a href="mailto:contact@teqa.app" className="text-rose-600 hover:underline">
                    contact@teqa.app
                  </a>
                </p>

                <p>
                  <strong>{t("contactPage.info.emails.sales")}:</strong>{" "}
                  <a href="mailto:sales@teqa.app" className="text-rose-600 hover:underline">
                    sales@teqa.app
                  </a>
                </p>

                <p>
                  <strong>{t("contactPage.info.emails.support")}:</strong>{" "}
                  <a href="mailto:support@teqaconnect.com" className="text-rose-600 hover:underline">
                    support@teqaconnect.com
                  </a>
                </p>

                <p>
                  <strong>{t("contactPage.info.emails.billing")}:</strong>{" "}
                  <a href="mailto:billing@teqa.app" className="text-rose-600 hover:underline">
                    billing@teqa.app
                  </a>
                </p>

                <p>
                  <strong>{t("contactPage.info.emails.privacy")}:</strong>{" "}
                  <a href="mailto:privacy@teqa.app" className="text-rose-600 hover:underline">
                    privacy@teqa.app
                  </a>
                </p>
              </div>

              {/* Address */}
              <div className="mt-8">
                <h3 className="font-semibold text-gray-900">
                  {t("contactPage.info.addressTitle")}
                </h3>
                <p className="mt-2 text-gray-600 whitespace-pre-line">
                  {t("contactPage.info.address")}
                </p>
              </div>

              {/* Social */}
              <div className="mt-8">
                <h3 className="font-semibold text-gray-900">
                  {t("contactPage.info.follow")}
                </h3>

                <div className="mt-4 flex flex-wrap gap-4">
                  {["Instagram", "Facebook", "LinkedIn", "X"].map((s) => (
                    <a
                      key={s}
                      href="#"
                      className="text-gray-600 hover:text-rose-600"
                    >
                      {s}
                    </a>
                  ))}
                </div>
              </div>
            </div>

            {/* RIGHT FORM */}
            <div className="rounded-2xl bg-white p-8 shadow-sm">
              <h2 className="text-2xl font-semibold text-gray-900">
                {t("contactPage.form.title")}
              </h2>

              <form className="mt-6 space-y-5">
                <input
                  type="text"
                  placeholder={t("contactPage.form.name")}
                  className="w-full rounded-xl border px-4 py-3 focus:border-rose-500 focus:outline-none"
                />

                <input
                  type="email"
                  placeholder={t("contactPage.form.email")}
                  className="w-full rounded-xl border px-4 py-3 focus:border-rose-500 focus:outline-none"
                />

                <textarea
                  rows="5"
                  placeholder={t("contactPage.form.message")}
                  className="w-full rounded-xl border px-4 py-3 focus:border-rose-500 focus:outline-none"
                />

                <button
                  type="submit"
                  className="w-full rounded-xl bg-rose-600 px-6 py-3 font-semibold text-white hover:bg-rose-700"
                >
                  {t("contactPage.form.submit")}
                </button>
              </form>
            </div>

          </div>
        </div>
      </section>
    </main>
  );
}
